import React, { createContext, useContext, PropsWithChildren, useState, useEffect } from "react";
import { makeFailure, makeSuccess, TResult } from "@sg-core/index";
import { IFile } from "../models/IFile";
import { IUploadOptions } from "../models/IUploadOptions";


const Context = createContext<IUploadOptions | undefined>(undefined);

export const useFileUploadContext = () => useContext(Context);

interface IFileUploadProiderProps {
    options: IUploadOptions;
}

export const FileUploadProvider: React.FC<PropsWithChildren<IFileUploadProiderProps>> = ({ options, children }) => {
    return (
        <Context.Provider value={options}>
            {children}
        </Context.Provider>
    );
};

export const useFileUrl = (fileId: IFile["id"], options?: { height?: number, width?: number }) => {
    const { getFileUrl, getThumbnailUrl } = useFileUploadContext() || {};

    const [fileUrl, setFileUrl] = useState<TResult<string>>();

    const loadFileUrl = async () => {
        try {
            const fetcher = (options?.height || options?.width) ? getThumbnailUrl : getFileUrl;
            if (!fetcher) {
                throw Error("missing fetcher");
            };
            const fileUrl = await fetcher(fileId, options);
            setFileUrl(makeSuccess(fileUrl));
        } catch (error) {
            setFileUrl(makeFailure(error as Error))
        }
    };

    useEffect(() => {
        if (!fileUrl) {
            loadFileUrl();
        }
    }, [fileId, fileUrl]);

    return {
        loading: !fileUrl,
        loadError: fileUrl?.isFailure ? fileUrl.error.message : undefined,
        reload: loadFileUrl,
        fileUrl: fileUrl?.isSuccess ? fileUrl.value : undefined
    };
};